module.exports = __webpack_public_path__ + "img/nekouzr.86029d91.jpg";